import Interaction from "./Interaction";
import { InteractionType } from "./Interaction";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import MathNodePreview from "../../features/sequence/node_previews/MathNodePreview";

export enum MathOperator {
  Add = "ADD",
  Subtract = "SUBTRACT",
  Multiply = "MULTIPLY",
  Divide = "DIVIDE",
  Modulo = "MODULO",
}

export const MATH_OPERATOR_LABELS: Record<MathOperator, string> = {
  [MathOperator.Add]: "Add",
  [MathOperator.Subtract]: "Subtract",
  [MathOperator.Multiply]: "Multiply",
  [MathOperator.Divide]: "Divide",
  [MathOperator.Modulo]: "Modulo",
};

export interface IMath extends Interaction {
  operator: MathOperator;
  input: number | string; // Variable ID or literal value
  amount: number | string; // Variable ID or literal value
  output: string; // Variable ID to store result
}

export const mathInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IMath => {
    return {
      id: GetNewGuid(),
      name: "Math",
      type: InteractionType.Math,
      operator: MathOperator.Add,
      input: 0,
      amount: 0,
      output: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IMath => {
    return interaction as IMath;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): IMath => {
    const original = interaction as IMath;
    return {
      id: GetNewGuid(),
      name: "Math",
      type: InteractionType.Math,
      operator: original.operator,
      input: original.input,
      amount: original.amount,
      output: original.output,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const filterType = "Math";

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    return getMatchingResults(
      [interaction.name],
      takeName,
      interaction,
      filterType
    );
  };

  const validateError = (interaction: Interaction): string[] => {
    const casted = interaction as IMath;
    const errors: string[] = [];

    if (!casted.output) {
      errors.push("Please select an output variable");
    }

    return errors;
  };

  return {
    View: <div>Math Node</div>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <MathNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    FilterType: filterType,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
